// extracted by css-extract-rspack-plugin
export default {"dragHandleContainer":"c6jCk","dragHandle":"cY1OU"};